export default {
  LIST_INIT: 'LIST_INIT',
  LIST_ADD: 'LIST_ADD',
  LIST_SAVE: 'LIST_SAVE',
  // LIST_UPDATE_COUNT: 'LIST_UPDATE_COUNT',
  LIST_DELETE: 'LIST_DELETE',
};


// WEBPACK FOOTER //
// ./modules/list/constants/ListConstants.js